import { Tabs } from 'react-bootstrap';
import styled from 'styled-components';

import { otherColors } from '@/styles/colors';

const TabsStyled = styled(Tabs)`
  .nav-item {
    flex: 1;
    text-decoration: none;
    color: #5a5a5a;
    border-radius: 8px 8px 0 0;
    text-align: center;

    &.active {
      color: ${otherColors.lxc.blue};
    }
  }
`;

export { TabsStyled as Tabs };
